import React from "react";
import { Button, Divider, Form } from "semantic-ui-react";
import MyDropzone from "../common/MyDropzone";
import { Categories } from "./model";
import { useExtLabels } from '../common/extLabels'

const Submission = ({ model, errors = {}, onChange, onRemove, disabled }) => {
    const l = useExtLabels()

    const handleChange = (e, { name, value }) => {
        const mdl = { ...model, [name]: value };
        onChange(mdl);
    };

    const handleFileDrop = (key, files) => {
        onChange({ ...model, [key]: files[0] });
    };

    const removeSubmission = e => {
        e.preventDefault();
        onRemove(model.key);
    };

    return (
        <div>
            <Divider />
            <Button floated="right" negative onClick={removeSubmission}>
                {l('Usuń')}
            </Button>
            <h2>{l('Kategoria')} {model.key + 1}</h2>

            <Form.Input
                disabled={disabled}
                label={l("Tytuł zgłoszenia (będzie wykorzystane przy ewentualnej nominacji)")}
                name="title"
                value={model.title}
                onChange={handleChange}
                required
                maxLength={200}
                error={!!errors.title}
            />

            <Form.TextArea
                disabled={disabled}
                label={l("Opis zgłoszenia (400-1000 znaków)")}
                rows={4}
                maxLength={1000}
                error={!!errors.description}
                name="description"
                value={model.description}
                onChange={handleChange}
                required
            />

            {Categories.map((c, i) => (
                <CategorySet
                    key={i}
                    label={c[0]}
                    categories={c.slice(1)}
                    checked={model.category}
                    error={!!errors.category}
                    disabled={disabled}
                    onChange={handleChange}
                />
            ))}

            <h3>{l('Prezentacja')}</h3>
            <Form.Field error={!!errors.presentation}>
                <MyDropzone
                    disabled={disabled}
                    onDropAccepted={files => handleFileDrop("presentation", files)}
                    multiple={false}
                    className={model.logo ? "dropzone uploaded" : "dropzone"}
                    accept="application/pdf"
                    maxSize={10 * 1024 * 1024}
                >
                    {!model.presentation && (
                        <div className="required field">
                            <label>{l('Przeciągnij prezentację zgłaszanego podmiotu')}</label>
                            <br />
                            <small>{l('(format pdf; maksymalny rozmiar 5MB)')}</small>
                        </div>
                    )}
                    {model.presentation && <div>{l('Prezentacja gotowa do przesłania')}: {model.presentation.name}</div>}
                </MyDropzone>
            </Form.Field>
        </div>
    );
};

export default Submission;

const CategorySet = ({ categories, label, onChange, checked, disabled, error }) => {

    const strip = (c) => c.indexOf("(") >= 0 ? c.substring(0, c.indexOf("(")) : c

    return (
        <Form.Group grouped>
            {label && <h3>{label}</h3>}
            {categories.map(c => (
                <Form.Radio
                    name="category"
                    disabled={disabled}
                    label={c}
                    key={c}
                    value={strip(c)}
                    checked={checked === strip(c)}
                    onChange={onChange}
                    error={error}
                />
            ))}
        </Form.Group>
    );
};
